import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IProductPricing, ProductPricing } from './ProductPricing'

export class ProductPricingMapper implements ICollectionMapper<ProductPricing> {
  map(data: IProductPricing): ProductPricing {
    const productPricing = new ProductPricing(data.description)
    productPricing.id = data.id
    productPricing.description = data.description
    productPricing.price = data.price
    productPricing.quantityType = data.quantityType || undefined

    return productPricing
  }

  serialize(object: ProductPricing): IProductPricing {
    return JSON.parse(JSON.stringify(object))
  }
}
